# src/components/form/PasswordRequirements.vue
<template>
  <div class="password-requirements">
    <div
      v-for="(requirement, index) in requirements"
      :key="index"
      class="requirement-item"
      :class="{ 'is-valid': requirement.valid }"
    >
      <check-circle-outlined v-if="requirement.valid" class="icon valid" />
      <exclamation-circle-outlined v-else class="icon" />
      {{ requirement.text }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons-vue";

const props = defineProps<{
  password: string;
}>();

const { t } = useI18n();

const requirements = computed(() => [
  {
    text: t("auth.passwordLength"),
    valid: props.password.length >= 8,
  },
  {
    text: t("auth.passwordHasNumber"),
    valid: /\d/.test(props.password),
  },
  {
    text: t("auth.passwordHasLetter"),
    valid: /[a-zA-Z]/.test(props.password),
  },
]);
</script>

<style scoped lang="less">
@import "@/assets/styles/variables.less";

.password-requirements {
  margin-top: 8px;
  padding: 12px;
  border-radius: 6px;
  background: @grey-2;

  .requirement-item {
    display: flex;
    align-items: center;
    gap: 8px;
    color: @grey-65;
    font-size: @font-size-sm;
    line-height: 24px;

    .icon {
      font-size: 14px;
      color: @warning-color;

      &.valid {
        color: @success-color;
      }
    }

    &.is-valid {
      color: @grey-45;
    }
  }
}
</style>
